
    import '/mnt/src/components/Form/index.md?watch=parent';
    export const demoIndex = {
  ids: ["form-demo-demo1","form-demo-validation"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Form/index.md?type=demo')
};